"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const react_responsive_1 = require("react-responsive");
const reducers_1 = require("../../reducers");
class ReportPreview extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.passRefToParent(this.iframe);
    }
    render() {
        const { simulatorURL } = this.props;
        return (React.createElement(react_responsive_1.default, { minWidth: 1140 }, ReactDOM.createPortal(React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    position: 'absolute',
                    top: 96,
                    left: 24,
                    textAlign: 'center',
                    width: 320,
                    height: 568,
                    background: 'white linear-gradient(rgba(233,233,233,1.0), rgba(238,238,238,0.5))',
                    zIndex: 10,
                } }),
            React.createElement("iframe", { id: "experience-preview-report-page", ref: (elem) => (this.iframe = elem), src: simulatorURL, style: {
                    position: 'absolute',
                    top: 96,
                    zIndex: 11,
                    left: 24,
                    height: 568,
                    width: 320,
                } })), document.getElementById('phone-bezel'))));
    }
}
const mapStateToProps = (state, ownProps) => ({
    simulatorURL: reducers_1.getExperiencePreviewURL(state, ownProps.campaignId),
});
exports.default = react_redux_1.connect(mapStateToProps, {})(ReportPreview);
